
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';
import { ChaseOrderInvoiceProcessInput } from '../Model/ChaseOrderInvoiceProcessInput';
import { ChaseOrderInvoiceProcessOutput } from '../Model/ChaseOrderInvoiceProcessOutput';
import { GetEnvVarService } from "../../../../service/get-env-var.service";

@Injectable()
export class OrderInvoiceStatusService {

  private baseUrl: string;

  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
  }

  getTransactionStatusFromUID(uId: string): Observable<ChaseOrderInvoiceProcessOutput> {
    // debugger;
    return this.http.get<ChaseOrderInvoiceProcessOutput>(`${this.baseUrl}/api/invoice/getTransactionStatusFromUID/${uId}`);
  }

}
